// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskFeedbackStyleEnum } from './taskFeedbackStyleEnum';

/**
 * Settings for generating feedback on a task submission
defined for each task
 */
export interface TaskFeedbackSettingsInput {
  style: TaskFeedbackStyleEnum;
}
